<template>
  <div>
    <div class="container-md">
      <div class="container-bg p-4">
        <div class="d-flex" style="justify-content: space-between">
          <h3>Beheer Informatiegroepen</h3>
          <div>
            <button
              @click="setParentId(1)"
              data-target="#itemGroup"
              data-toggle="modal"
              class="btn btn-dark btn-sm mr-3"
            >
              <i class="fas fa-plus"></i> Informatiegroep
            </button>
            <!-- <button
              data-target="#createItemModal"
              data-toggle="modal"
              class="btn btn-dark btn-sm"
            >
              Add Item
            </button> -->
          </div>
        </div>
        <div class="row mt-5">
          <div
            class="col-10 ml-auto d-flex"
            style="justify-content: space-between"
          >
            <div class="form-group w-50">
              <button @click="closeAll()" class="btn btn-dark btn-sm">
                Alles sluiten
              </button>
            </div>

            <div class="form-group w-100">
              <form action="" class="form-inline ml-auto row mr-3">
                <div class="form-group col-9">
                  <input
                    style="width: 100%"
                    v-model="title"
                    type="text"
                    class="form-control"
                    placeholder="Zoeken"
                  />
                </div>
                <div class="form-group col-2">
                  <button
                    type="button"
                    @click="search()"
                    class="btn btn-dark btn-sm"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div v-for="group in list" :key="'group_' + group.id">
              <itemgroup
                :committees="committees"
                :members="members"
                :group="group"
                v-if="group.parent_id == 0"
              ></itemgroup>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--        ITEMGROUP Modal-->
    <createItemgroup
      :committees="committees"
      :members="members"
    ></createItemgroup>

    <!-- ITEM MODAL -->
    <createItem></createItem>
  </div>
</template>
<script>
import { mapState } from "vuex";
import createItemgroup from "./create";
import createItem from "./create-item";
import itemgroup from "./itemgroup";
export default {
  components: {
    itemgroup: itemgroup,
    createItemgroup,
    createItem,
  },
  data() {
    return {
      list: [],
      members: [],
      create_itemgroup: { active: false, public: false, parent_id: 0 },
      title: "",
      committees: [],
    };
  },
  computed: {
    ...mapState({
      itemgroup_parent_id: (state) => state.itemgroup_parent_id,
    }),
  },
  methods: {
    closeAll() {
      window.$(".group-item").addClass("collapsed");
      window.$(".collapse").removeClass("show");
    },
    search() {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/itemgroups/search",
          details: { search: [{ attribute: "title", value: this.title }] },
        })
        .then((data) => {
          this.list = data.data.data;
        });
    },
    notifyState() {
      setTimeout(() => {
        this.members = this.resolveMembers();
      }, 300);
    },
    resolveMembers() {
      var users_list = this.committees
        .filter((d) => d.selected)
        .map((d) => d.users);
      var members = [];
      users_list.forEach((list) => {
        members = [...list, ...members];
      });
      return members;
    },
    setParentId(id) {
      this.$store.state.itemgroup_parent_id = id;
    },
  },
  async created() {
    await this.$store
      .dispatch("get", "api/v1/committees/all/parent-id")
      .then(({ data }) => {
        data.data.forEach((item) => {
          this.committees.push({
            value: item.id,
            label: item.title,
            disabled: item.active,
          });
        });
      });

    await this.$store
      .dispatch("get", "/api/v1/active/users")
      .then(({ data }) => {
        data.data.forEach((item) => {
          this.members.push({
            value: item.id,
            label: item.display_name,
            disabled: item.disabled,
          });
        });
      });

    await this.$store.dispatch("get", "api/v1/itemgroups").then(({ data }) => {
      this.list = data.data;
    });
  },
};
</script>
<style scoped>
@media (max-width: 650px) {
  .list-btn {
    font-size: 15px !important;
    margin-right: 0px !important;
  }
}
@media (max-width: 500px) {
  .list-btn {
    margin-top: 15px;
  }
}
</style>
